import React from 'react';
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import MediaStreamRecorder from 'msr';

import Header from '../Header/Header';
import Dashboard from '../Dashboard/Dashboard';
import Reports from '../StreamReports/StreamReports';
import Map from '../Map/Map';
import IfbModal from '../IfbModal/IfbModal';
import UserArea from '../UserArea/UserArea';

import { APIs, EXPORT_APIS, webSocketEndPoint } from '../../constants/endPointsURLs';
import { LicensePermissions } from '../LicensePermissions/LicensePermissions';
import { saveReportToHistory } from '../StreamReports/StreamReportsHistoryUtils';
import { calculateStreamScore } from '../StreamReports/StreamReportsUtils';
import config from '../../dashboard_config.json';

import {
  DASHBOARD_TO_PRIMARY_MSG,
  DASHBOARD_TO_PRIMARIES_MSG,
  PRIMARY_TO_DASHBOARD_MSG,
  DASHBOARD_TO_CENTRAL_SERVER_MSG,
  CENTRAL_SERVER_TO_DASHBOARD_MSG,
  KEEP_ALIVE_MSG,
  IFB_MSG,
  START_SESSION_MSG,
  STOP_SESSION_MSG,
  GET_PRIMARY_SETTINGS_MSG,
  SET_PRIMARY_SETTINGS_MSG,
  SET_DESIGNATED_OUTPUT,
  DIALOG_ALERT_RESPONSE,
  PrimaryToDashboardMsgSubtypes,
  alertsTypes,
  alertDialogType,
  GET_DEVICE_RECORDS,
  START_RECORD_UPLOAD,
  PAUSE_RECORD_UPLOAD,
  DELETE_RECORD,
} from '../../constants/webSocketMsgsTypesMap';

import {
  shortToByteArray,
  longToByteArray,
  intToByteArray,
} from '../../utils/ConvertToByteArray';

import availableBroadcastSettings from '../../constants/availableBroadcastSettings';
import Modal from '../common/Modal/Modal';

//--------------- Main.js local constants ---------------//
const MAX_LOGS_PER_PRIMARY = 100;
//-------------------------------------------------------//

let availableBroadcastSettingsObj = {};
availableBroadcastSettings.forEach((obj) => {
  availableBroadcastSettingsObj[obj.id] = obj.valuesArray;
});

class Main extends React.Component {
  state = {
    broadcastDetailsJsonObject: {},
    companyName: 'user',
    adminFirstName: 'user',
    adminLastName: 'user',
    primaryUsers: [],
    primariesDisplayedNames: {},
    arePrimaryUsersLoading: true,
    outputs: [],
    outputsDisplayedNames: {},
    areOutputsLoading: true,
    videoServerStatus: {},

    focusedPrimaryId: '',
    isChangingStartStopInProgress: false,

    focusedPrimaryBroadcastSettings: {},
    arePrimaryBroadcastSettingsLoading: false,
    arePrimaryRecordsLoading: false,

    IFBbytesPerSample: 2,

    primariesAlarms: {},
    primariesLogs: {},
    primariesBroadcastDetails: [],
    primariesUserDetails: [],
    broadcastProperties: [],
    devicesSetsInfo: {},
    isDevicesSetsInfoLoading: false,

    isNotificationDisplayed: false,
    currentNotificationType: '',
    notificationRelatedPrimaryName: '',
    notificationRelatedOutputName: '',

    isAlertDialogDisplayed: false,
    currentAlertDialogType: '',
    alertDialogPrimaryId: '',

    primaryRecordsDetails: [],
    primariesSessionData: {},

    showDashboardPage: true,
    showMapPage: false,

    audioDevices: [],
    selectedDevice: '',
    isAudioChannelOpen: false,
    toggleRefresh: false,

    isUserCorporate: false,
    isUserVideographer: false,
    isUserInfluencer: false,
    isUserFreeTrial: false,
    isUserMyKey: false,
    isUserBasic: false,
    isUserLiveOmni: false,
    isUserGuest: false,

    guestsTotal: 0,
    guestsTotalHistory: 0,
    guestsRemain: 0,
    guestsFreeTrialRemain: 0,
    guestsMax: 0,
    guestsCurrentCount: 0,
    fetchExportList: undefined,

    notificationsHistory: [],
  };

  componentWillUnmount() {
    clearInterval(this.scheduler);
    clearInterval(this._keepAliveInterval);
    if (this._faviconPulseInterval) clearInterval(this._faviconPulseInterval);
    if (this._healthPollInterval) clearInterval(this._healthPollInterval);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    // this.closeConnectionToServer();
  }

  componentDidUpdate(prevProps, prevState) {
    // Favicon live notification pulse check
    if (document.visibilityState === 'hidden') {
      const isAnyoneLive = this.state.primaryUsers.some(user => user.isBroadcasting);
      const wasAnyoneLive = prevState.primaryUsers.some(user => user.isBroadcasting);

      if (isAnyoneLive !== wasAnyoneLive) {
        this._toggleFaviconPulse(isAnyoneLive);
      }
    }

    if (prevState.primaryUsers.length === 0 && this.state.primaryUsers.length > 0) {
      this.handlePrimaryFocus(this.state.primaryUsers[0].id);
    }

    if (prevState.focusedPrimaryId !== this.state.focusedPrimaryId) {
      const currentUser = this.state.primariesUserDetails.find(
        (user) => user.primaryId === this.state.focusedPrimaryId
      );
      if (currentUser) {
        const licensePermissions = {
          isUserCorporate: currentUser.licensePermissionId === LicensePermissions.CORPORATE,
          isUserVideographer: currentUser.licensePermissionId === LicensePermissions.VIDEOGRAPHER,
          isUserInfluencer: currentUser.licensePermissionId === LicensePermissions.INFLUENCER,
          isUserFreeTrial: currentUser.licensePermissionId === LicensePermissions.FREE_TRIAL,
          isUserMyKey: currentUser.licensePermissionId === LicensePermissions.MYKEY,
          isUserBasic: currentUser.licensePermissionId === LicensePermissions.BASIC,
          isUserLiveOmni: currentUser.licensePermissionId === LicensePermissions.LIVE_OMNI,
          isUserGuest: currentUser.licensePermissionId === LicensePermissions.GUEST,
        };
        this.setState(licensePermissions);
      } else {
        this.setState({
          isUserCorporate: false,
          isUserVideographer: false,
          isUserInfluencer: false,
          isUserFreeTrial: false,
          isUserMyKey: false,
          isUserBasic: false,
          isUserLiveOmni: false,
          isUserGuest: false,
        });
      }
    }
  }

  isAtLeastOneCorporateLicense() {
    return this.state.primariesUserDetails.some(user => user.licensePermissionId === LicensePermissions.CORPORATE);
  }

  componentDidMount() {
    this.scheduler = setInterval(() => {
      this.getControllerInfo();
    }, 10 * 60000);

    this.getControllerInfo();

    if (localStorage.getItem('pagesTabsState') !== null) {
      const { showDashboardPage, showMapPage } = JSON.parse(
        localStorage.getItem('pagesTabsState')
      );
      this.setState({
        showDashboardPage,
        showMapPage,
      });
    } else {
      this.savePagesTabsStateToLocalStorage();
    }

    if (localStorage.getItem('primariesDisplayedNames') !== null) {
      const primariesDisplayedNames = JSON.parse(
        localStorage.getItem('primariesDisplayedNames')
      );
      this.setState({ primariesDisplayedNames });
    }

    if (localStorage.getItem('outputsDisplayedNames') !== null) {
      const outputsDisplayedNames = JSON.parse(
        localStorage.getItem('outputsDisplayedNames')
      );
      this.setState({ outputsDisplayedNames });
    }

    // Visibility listener for dynamic favicon
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    const isAnyoneLive = this.state.primaryUsers.some(user => user.isBroadcasting);
    this._toggleFaviconPulse(document.visibilityState === 'hidden' && isAnyoneLive);
  };

  _toggleFaviconPulse = (shouldPulse) => {
    if (this._faviconPulseInterval) {
      clearInterval(this._faviconPulseInterval);
      this._faviconPulseInterval = null;
    }

    if (!shouldPulse || document.visibilityState === 'visible') {
      this._updateFavicon(false);
      return;
    }

    let alpha = 1.0;
    let direction = -0.05;

    // Breath effect: update every 100ms for smoothness
    this._faviconPulseInterval = setInterval(() => {
      this._updateFavicon(true, alpha);
      alpha += direction;
      if (alpha <= 0.4 || alpha >= 1.0) direction *= -1;
    }, 100);
  };

  _updateFavicon = (showActive, alpha = 1.0) => {
    const faviconElement = document.querySelector('link[sizes="32x32"]');
    if (!faviconElement) return;

    if (!showActive) {
      // Restore default
      faviconElement.href = '/favicon-32x32.png';
      return;
    }

    // Create the "Recording" overlay
    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = '/favicon-32x32.png';

    img.onload = () => {
      ctx.clearRect(0, 0, 32, 32);
      // Draw original icon (full opacity)
      ctx.globalAlpha = 1.0;
      ctx.drawImage(img, 0, 0, 32, 32);

      // Overlay pulsing red dot
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.arc(24, 8, 5.5, 0, 2 * Math.PI);
      ctx.fillStyle = '#ff0000';
      ctx.fill();

      // White border for better visibility on dark tabs
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#ffffff';
      ctx.stroke();

      faviconElement.href = canvas.toDataURL('image/png');
    };
  };

  _webSocket;
  _recorders = {};

  isWebSocketConnected = () => {
    if (this._webSocket && this._webSocket.readyState === WebSocket.OPEN) {
      return true;
    }
    return false;
  };

  connectWebSocket = () => {
    this._webSocket = new WebSocket(webSocketEndPoint);

    this._webSocket.onopen = () => {
      // List cameras and microphones.

      this.checkPermissions();

      clearInterval(this._keepAliveInterval);
      this._keepAliveInterval = setInterval(() => {
        if (this.isWebSocketConnected()) {
          let arrBuffer = new Int8Array(2); //ping msg
          const typeArr = shortToByteArray(KEEP_ALIVE_MSG);
          // const companyId = longToByteArray(this.state.companyId);
          arrBuffer.set(typeArr, 0);
          // arrBuffer.set(companyId,2);
          this._webSocket.send(arrBuffer);
        } else {
          clearInterval(this._keepAliveInterval);
        }
      }, 10000);

      clearInterval(this._healthPollInterval);
      this._healthPollInterval = setInterval(() => {
        this._pollActivePrimariesHealth();
      }, 30000);

      // Trigger initial poll immediately
      this._pollActivePrimariesHealth();
    };

    this._webSocket.onmessage = (e) => {
      this.__parseWebSocketMessage(e.data, this.state.focusedPrimaryId).then(
        (messageDataIncludingType) => {
          const { messageType, ...messageData } = messageDataIncludingType;
          if (messageType === 'settings_change') {
            const { primaryId, ...returnedSettings } = messageData;

            // Track new events and update state in a single functional update
            this.setState((prevState) => {
              const prevSession = prevState.primariesSessionData[primaryId];
              const session = this._buildSessionObject(primaryId, prevSession || {});

              // 1. Track setting changes for summary
              for (let setting in returnedSettings) {
                const isValidSetting = availableBroadcastSettings.some(s => s.id === setting);
                if (!isValidSetting) continue;

                if (!session.streamSettings) session.streamSettings = {};

                const oldVal = session.streamSettings[setting];
                const newVal = returnedSettings[setting];

                if (oldVal !== undefined && oldVal !== newVal) {
                  session.settingChanges = [
                    ...(session.settingChanges || []),
                    {
                      time: new Date().toLocaleTimeString(),
                      setting,
                      from: oldVal,
                      to: newVal
                    }
                  ];
                }
              }

              // 2. Detect & Log New Alarms
              const newAlarmsList = returnedSettings.alarmsPrimary || [];
              const prevAlarmsList = (prevSession && prevSession.streamSettings && prevSession.streamSettings.alarmsPrimary) || [];
              let primariesLogs = { ...prevState.primariesLogs };

              newAlarmsList.forEach(alarm => {
                const message = alarm.message || alarm.Description || alarm.description || alarm.name || alarm.Name;
                const messageType = alarm.name || alarm.Name || 'Alarm';

                // Guard: Only add logs if primary is currently broadcasting and session is active
                const primaryObj = prevState.primaryUsers.find(u => u.id === primaryId);
                const isBroadcasting = primaryObj ? primaryObj.isBroadcasting : false;
                if (!isBroadcasting || !prevState.primariesSessionData[primaryId]) return;

                // Compare against the PREVIOUS state's alarms to see if it's new
                const exists = prevAlarmsList.some(a => (a.message || a.Description || a.description || a.name || a.Name) === message);

                if (!exists) {
                  const time = new Date().toLocaleTimeString();
                  const newLogObj = { type: 'warning', message, time };

                  // Update Global Logs
                  primariesLogs[primaryId] = [newLogObj, ...(primariesLogs[primaryId] || [])].slice(0, 50);

                  // Update Session Data for Reports
                  session.alarms = [...(session.alarms || []), { time, name: messageType, message }];
                  session.logs = [...(session.logs || []), { time, type: 'warning', message }];
                }
              });

              // 3. Update Current Settings
              session.targetBitrate = returnedSettings.maxBitrate || session.targetBitrate;
              session.streamSettings = {
                ...session.streamSettings,
                ...returnedSettings,
              };

              const newState = {
                primariesSessionData: {
                  ...prevState.primariesSessionData,
                  [primaryId]: session,
                },
                primariesLogs
              };

              // 4. Update UI settings if this is the focused primary
              if (primaryId === prevState.focusedPrimaryId) {
                newState.focusedPrimaryBroadcastSettings = {
                  ...prevState.focusedPrimaryBroadcastSettings,
                  ...returnedSettings,
                };
              }

              return newState;
            });
          } else if (messageType === 'alert' || messageType === 'dialog_alert_message') {
            const { primaryId, alertType, alertMessage, time } = messageData;

            const rawMsg = alertMessage || messageData.message || messageData.dialogType || '';
            const capitalizedMessage = rawMsg ?
              rawMsg.slice(0, 1).toUpperCase() + rawMsg.slice(1) : '';

            const newLogObj = {
              type: alertType || 'warning',
              message: capitalizedMessage,
              time: time || new Date().toLocaleTimeString(),
            };

            let primariesLogs = { ...this.state.primariesLogs };

            // Log rejection/alert in primary logs list (works even if primary is not actively broadcasting)
            if (primaryId) {
              if (primariesLogs[primaryId] !== undefined) {
                primariesLogs[primaryId].unshift(newLogObj);
                primariesLogs[primaryId] = primariesLogs[primaryId].slice(
                  0,
                  MAX_LOGS_PER_PRIMARY
                );
              } else {
                primariesLogs[primaryId] = [newLogObj];
              }

              this.setState({ primariesLogs });

              // Also persist to session data if active
              this.setState(prevState => {
                const currentSessionData = prevState.primariesSessionData[primaryId];
                if (!currentSessionData) return null;
                const session = this._buildSessionObject(primaryId, currentSessionData);

                const newAlarm = {
                  time: time || new Date().toLocaleTimeString(),
                  name: 'Alert',
                  message: capitalizedMessage
                };

                session.alarms = [...(session.alarms || []), newAlarm];
                session.logs = [...(session.logs || []), {
                  time: time || new Date().toLocaleTimeString(),
                  type: alertType || 'warning',
                  message: capitalizedMessage
                }];

                return {
                  primariesSessionData: {
                    ...prevState.primariesSessionData,
                    [primaryId]: session
                  }
                };
              });
            }
          } else if (messageType === 'bitrate') {
            const { primaryId, bitrate, duration, operators } = messageData;
            const formatedBitrate = this._formatBitrateToString(bitrate);
            const formatedDuration = this._formatDurationToString(duration + 1); // Addiding offset of 1 in order to fix the constant delay of 1 sec in displayed duration
            let primariesBroadcastDetails = [
              ...this.state.primariesBroadcastDetails,
            ];
            let broadcastProperties = [...this.state.broadcastProperties];
            const i = primariesBroadcastDetails.findIndex(
              (obj) => obj.primaryId === primaryId
            );
            const k = broadcastProperties.findIndex(
              (obj) => obj.primaryId === primaryId
            );

            //--------------------------------Conditions for primariesBroadcastDetails---------------------------------------------

            if (i > -1) {
              const targetPrimary = primariesBroadcastDetails[i];
              const isInitial = targetPrimary.operatorsDataArr.length === 0;
              const formatedOperatorsArr = this.formOperatorsData(bitrate, operators, isInitial);

              if (isInitial) {
                primariesBroadcastDetails[i] = {
                  ...targetPrimary,
                  operatorsDataArr: formatedOperatorsArr
                };
              } else {
                primariesBroadcastDetails[i] = this.updatePrimariesBrodcastDetails(
                  formatedBitrate,
                  formatedDuration,
                  formatedOperatorsArr,
                  primariesBroadcastDetails,
                  i
                );
              }
            } else {
              const formatedOperatorsArr = this.formOperatorsData(
                bitrate,
                operators,
                true
              );
              const newPrimaryBroadcastDetailsObj = {
                primaryId,
                bitrateArr: [formatedBitrate],
                durationArr: [formatedDuration],
                operatorsDataArr: formatedOperatorsArr,
              };
              primariesBroadcastDetails.push(newPrimaryBroadcastDetailsObj);
            }

            //--------------------------------Conditions for broadcastProperties---------------------------------------------

            if (k > -1) {
              broadcastProperties[k] = {
                ...broadcastProperties[k],
                bitrateArr: [...broadcastProperties[k].bitrateArr, formatedBitrate].slice(-300),
                durationArr: [...broadcastProperties[k].durationArr, formatedDuration].slice(-300)
              };
            } else {
              const newPrimaryBroadcastDetailsObj = {
                primaryId,
                bitrateArr: [formatedBitrate],
                durationArr: [formatedDuration],
              };
              broadcastProperties.push(newPrimaryBroadcastDetailsObj);
            }

            if (operators) {
              operators['primaryId'] = primaryId;
            }

            // Consolidated Bitrate Update
            this.setState(prevState => {
              const prevSession = prevState.primariesSessionData[primaryId];
              const session = this._buildSessionObject(primaryId, prevSession || {});

              // 1. Technical Analytics (Focus-agnostic)
              const currentOperators = this.formOperatorsData(bitrate, operators, true);

              const currentSecondaries = currentOperators.length;
              if (currentSecondaries > (session.maxSecondaries || 0)) {
                session.maxSecondaries = currentSecondaries;
              }

              // 2. Connectivity Failure Analysis
              this.lastOperatorStates = this.lastOperatorStates || {};
              this.lastOperatorStates[primaryId] = this.lastOperatorStates[primaryId] || {};
              const currentTime = new Date().toLocaleTimeString();

              currentOperators.forEach(prov => {
                const provName = prov.operatorName || 'Unknown';
                const isLinkActive = parseFloat(prov.operatorData[prov.operatorData.length - 1]) > 0;
                const prevLinkState = this.lastOperatorStates[primaryId][provName];

                if (prevLinkState === undefined) {
                  this.lastOperatorStates[primaryId][provName] = isLinkActive;
                } else if (prevLinkState === true && !isLinkActive) {
                  this.lastOperatorStates[primaryId][provName] = false;
                  session.connectivityEvents = [
                    ...(session.connectivityEvents || []),
                    { time: currentTime, type: 'DISCONNECT', provider: provName, message: `Link '${provName}' disconnected` }
                  ];
                } else if (prevLinkState === false && isLinkActive) {
                  this.lastOperatorStates[primaryId][provName] = true;
                  session.connectivityEvents = [
                    ...(session.connectivityEvents || []),
                    { time: currentTime, type: 'RECONNECT', provider: provName, message: `Link '${provName}' reconnected` }
                  ];
                }
              });

              // 3. Update Session Metrics
              session.bitrateSamples = [...(session.bitrateSamples || []), bitrate];
              session.duration = formatedDuration;
              session.providerStats = currentOperators;

              return {
                primariesBroadcastDetails,
                broadcastProperties,
                broadcastDetailsJsonObject: operators,
                primariesSessionData: {
                  ...prevState.primariesSessionData,
                  [primaryId]: session
                }
              };
            });
          } else if (messageType === 'devices_info') {
            const { primaryId, devicesInfo } = messageData;

            this.setState(prevState => {
              const prevSession = prevState.primariesSessionData[primaryId];
              const session = this._buildSessionObject(primaryId, prevSession || {});

              // Preserve worst-case hardware stats for the report
              const updatedDeviceInfo = (devicesInfo || []).map(newDevice => {
                const prevDevice = (session.deviceInfo || []).find(d => d.id === newDevice.id) || {};
                return {
                  ...newDevice,
                  // Track lowest signal seen (default to 100% to find min)
                  signalStrength: Math.min(
                    (newDevice.signalStrength !== undefined && newDevice.signalStrength !== null) ? newDevice.signalStrength : 100,
                    (prevDevice.signalStrength !== undefined && prevDevice.signalStrength !== null) ? prevDevice.signalStrength : 100
                  ),
                  // Track highest temperature seen
                  temperature: Math.max(
                    (newDevice.temperature !== undefined && newDevice.temperature !== null) ? newDevice.temperature : 0,
                    (prevDevice.temperature !== undefined && prevDevice.temperature !== null) ? prevDevice.temperature : 0
                  )
                };
              });

              session.deviceInfo = updatedDeviceInfo;

              return {
                devicesSetsInfo: {
                  ...prevState.devicesSetsInfo,
                  [primaryId]: devicesInfo
                },
                isDevicesSetsInfoLoading: false,
                primariesSessionData: {
                  ...prevState.primariesSessionData,
                  [primaryId]: session
                }
              };
            });
          } else if (messageType === 'primaries-outputs-videoServer-guestsTotal-guestsTotalHistory-guestsRemain-guestsFreeTrialRemain-guestsMax-guestsCurrentCount') {
            const {
              primaries,
              outputs,
              videoServer,
              guestsTotal,
              guestsTotalHistory,
              guestsRemain,
              guestsFreeTrialRemain,
              guestsMax,
              guestsCurrentCount, } = messageData;

            if (guestsTotal !== undefined) {
              this.setState({ guestsTotal });
            }

            if (guestsTotalHistory !== undefined) {
              this.setState({ guestsTotalHistory });
            }

            if (guestsRemain !== undefined) {
              this.setState({ guestsRemain });
            }

            if (guestsFreeTrialRemain !== undefined) {
              this.setState({ guestsFreeTrialRemain });
            }

            if (guestsMax !== undefined) {
              this.setState({ guestsMax });
            }

            if (guestsCurrentCount !== undefined) {
              this.setState({ guestsCurrentCount });
            }

            if (videoServer !== undefined) {
              const videoServerStatus = {
                generalStatus: videoServer.GeneralStatus,
                errors: videoServer.Errors || [],
              };

              this.setState({ videoServerStatus });
            }

            if (primaries !== undefined) {
              // let arr = [{id:0,username:'test'}];
              // if (this.state.companyType===1){
              // 	arr.concat(primaries);
              // }
              // console.log("Oren: "+primaries[0]);

              this._handlePrimariesStartStopStateChange(primaries);

              if (this.state.focusedPrimaryId) {
                const focusedPrimaryPrevObj = this.state.primaryUsers.find(
                  (obj) => obj.id === this.state.focusedPrimaryId
                );

                this.setState(
                  {
                    primaryUsers: primaries,
                    arePrimaryUsersLoading: false,
                  },
                  () => {
                    this._pollActivePrimariesHealth();
                    const focusedPrimaryNewObj = this.state.primaryUsers.find(
                      (obj) => obj.id === this.state.focusedPrimaryId
                    );

                    if (!focusedPrimaryNewObj) return;

                    if (
                      focusedPrimaryPrevObj.isActive !==
                      focusedPrimaryNewObj.isActive &&
                      focusedPrimaryPrevObj.isActive === true
                    ) {
                      this.setState(
                        {
                          arePrimaryBroadcastSettingsLoading: true,
                          isDevicesSetsInfoLoading: true,
                          devicesSetsInfo: {},
                        },
                        () => {
                          this._getFocusedPrimaryBroadcastSettings();
                        }
                      );
                    }
                  }
                );

              } else {
                this.setState({
                  primaryUsers: primaries,
                  arePrimaryUsersLoading: false,
                }, () => {
                  this._pollActivePrimariesHealth();
                });
              }
            }
            if (outputs !== undefined) {
              this.setState({
                outputs,
                areOutputsLoading: false,
              });

              let primariesAlarms = { ...this.state.primariesAlarms };

              outputs.forEach((output) => {
                if (output.primaryId !== null) {
                  let newAlarms = [];

                  if (
                    output.GeneralStatus === 'WARNING' ||
                    output.GeneralStatus === 'ERROR'
                  ) {
                    newAlarms = output.Statuses.map((status) => {
                      return {
                        name: status.Name,
                        type: status.Type,
                        message: status.Description,
                      };
                    });
                  }

                  primariesAlarms[output.primaryId] = newAlarms;

                  // Adding logs for every NEW alarm
                }
              });

              this.setState({ primariesAlarms });
            }
          } else if (messageType === 'dialog_alert_message') {
            if (this.state.isChangingStartStopInProgress) {
              this.setState({
                isAlertDialogDisplayed: messageData.isShown,
                currentAlertDialogType: messageData.dialogType,
                alertDialogPrimaryId: messageData.primaryId,
              });
            }
          } else if (messageType === 'device_records') {
            this.setState({
              primaryRecordsDetails: messageData.records,
              arePrimaryRecordsLoading: false,
            });
          } else if (messageType === 'record_percentage') {
            const { name, percentage } = messageData;
            const recordIndex = this.state.primaryRecordsDetails.findIndex(
              (record) => record.name === name
            );

            if (recordIndex !== -1) {
              const newRecords = [...this.state.primaryRecordsDetails];
              newRecords[recordIndex].percentage = percentage;
              this.setState({
                primaryRecordsDetails: newRecords,
              });
            }
          } else if (messageType === 'update_record') {
            const { name, status } = messageData;
            const recordIndex = this.state.primaryRecordsDetails.findIndex(
              (record) => record.name === name
            );

            if (recordIndex !== -1) {
              const newRecords = [...this.state.primaryRecordsDetails];
              newRecords[recordIndex].status = status;
              this.setState({
                primaryRecordsDetails: newRecords,
              });
            }
          }
        }
      );
    };

    this._webSocket.onerror = (err) => {
      console.error('Error in connection to server: ' + err.data);
    };

    this._webSocket.onclose = () => {
      clearInterval(this._healthPollInterval);
      this.getControllerInfo();
    };
  };

  closeConnectionToServer = () => {
    axios({
      method: 'get',
      url: APIs.logout,
      withCredentials: true,
    })
      .then(() => {
        this.props.setLogout();
      })
      .catch((err) => {
        console.error(err);
      });
    this._webSocket.close();
  };

  getAudioDevices() {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        let audioDevices = [];
        // let defaultSelectedDevice = {name:'No audio input',id:'',primaries:{},open:false};
        // audioDevices.push(defaultSelectedDevice);
        devices.forEach((device) => {
          if (
            device.kind === 'audioinput' &&
            device.deviceId !== 'communications' &&
            device.deviceId !== 'default'
          )
            audioDevices.push({
              name: device.label,
              id: device.deviceId,
              primaries: {},
              open: false,
            });
        });
        this.setState({ audioDevices: audioDevices });
      })
      .catch(function (err) {
        console.log(err.name + ': ' + err.message);
      });
  }

  createRecorder(deviceId) {
    let main = this;
    if (this._recorders[deviceId] !== undefined) {
      return;
    }
    navigator.mediaDevices
      .getUserMedia({
        // Check whether this code block can be removed as the below settings might be ignored
        audio: {
          latency: 0,
          sampleRate: { ideal: 8000 },
          channelCount: 1,
          echoCancellation: false,
          deviceId: deviceId,
        },
      })
      .then((stream) => {
        let recorder = new MediaStreamRecorder(stream);
        recorder.mimeType = 'audio/pcm';
        recorder.ondataavailable = (blob) => {
          // console.log('data!!')
          let audioDevices = this.state.audioDevices;
          audioDevices.forEach((audioDevice) => {
            if (audioDevice.id === deviceId) {
              let primaries = audioDevice.primaries;
              this.__sendIfbMessagesToPrimaries(primaries, blob);
            }
          });
        };
        main._recorders[deviceId] = recorder;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //---------------- WebSocket messages related methods ---------------//
  __parseWebSocketMessage(data, focusedPrimaryId) {
    return new Promise((resolve, reject) => {
      let parsedMessageData = {};

      const fileReader = new FileReader();
      fileReader.onload = function () {
        const arrayBuffer = this.result;
        const messageData = JSON.parse(
          String.fromCharCode.apply(null, new Uint8Array(arrayBuffer.slice(0)))
        );

        if (messageData.type === PRIMARY_TO_DASHBOARD_MSG) {
          const { primaryId, subType } = messageData;

          switch (PrimaryToDashboardMsgSubtypes[subType]) {
            case 'settings_change':
              parsedMessageData.messageType = 'settings_change';
              parsedMessageData.primaryId = primaryId;

              parsedMessageData.alarmsPrimary = messageData.alarms;

              parsedMessageData.camera =
                availableBroadcastSettingsObj.camera[
                  messageData.camera
                ].value;
              parsedMessageData.codec =
                availableBroadcastSettingsObj.codec[messageData.codec].value;
              parsedMessageData.frameRate =
                availableBroadcastSettingsObj.frameRate[
                  messageData.frameRate
                ].value;

              parsedMessageData.maxBitrate =
                availableBroadcastSettingsObj.maxBitrate[
                  messageData.maxBitrate
                ].value;
              parsedMessageData.broadcastType =
                availableBroadcastSettingsObj.broadcastType[
                  messageData.broadcastType
                ].value;
              parsedMessageData.resolution =
                availableBroadcastSettingsObj.resolution[
                  messageData.resolution
                ].value;
              parsedMessageData.scanMode =
                availableBroadcastSettingsObj.scanMode[
                  messageData.scanMode
                ].value;
              parsedMessageData.streamType =
                availableBroadcastSettingsObj.streamType[
                  messageData.streamType
                ].value;
              parsedMessageData.videoFluency =
                availableBroadcastSettingsObj.videoFluency[
                  messageData.videoFluency
                ].value;
              break;

            case 'alert':
              if (messageData.alertType >= 1) {
                parsedMessageData.messageType = 'alert';
                parsedMessageData.primaryId = primaryId;
                parsedMessageData.alertType = alertsTypes[messageData.logType];
                parsedMessageData.alertMessage = messageData.message;
                parsedMessageData.time = new Date().toLocaleTimeString();
              }
              break;

            case 'bitrate':
              parsedMessageData.messageType = 'bitrate';
              parsedMessageData.primaryId = primaryId;
              parsedMessageData.duration = messageData.duration;
              parsedMessageData.bitrate = (messageData.bitrate * 8) / 1000000;
              parsedMessageData.operators = messageData.operators;
              break;

            case 'devices_info':
              parsedMessageData.messageType = 'devices_info';
              parsedMessageData.primaryId = primaryId;
              parsedMessageData.devicesInfo = messageData.devicesInfo;
              break;

            case 'dialog_alert_message':
              parsedMessageData.messageType = 'dialog_alert_message';
              parsedMessageData.primaryId = primaryId;
              parsedMessageData.dialogType = messageData.dialogType;
              parsedMessageData.isShown = messageData.show;
              break;

            case 'device_records':
              parsedMessageData.messageType = 'device_records';
              parsedMessageData.records = messageData.records;
              break;

            case 'record_percentage':
              parsedMessageData.messageType = 'record_percentage';
              parsedMessageData.name = messageData.name;
              parsedMessageData.percentage = messageData.percentage;
              break;

            case 'update_record':
              parsedMessageData.messageType = 'update_record';
              parsedMessageData.name = messageData.name;
              parsedMessageData.status = messageData.status;
              break;

            default:
              parsedMessageData.messageType = 'undefined type';
          }
        } else if (messageData.type === CENTRAL_SERVER_TO_DASHBOARD_MSG) { // guests data can be fetched here...
          parsedMessageData.messageType = 'primaries-outputs-videoServer-guestsTotal-guestsTotalHistory-guestsRemain-guestsFreeTrialRemain-guestsMax-guestsCurrentCount';
          parsedMessageData.primaries = messageData.primaries;
          parsedMessageData.outputs = messageData.outputs;
          parsedMessageData.videoServer = messageData.videoServer;

          parsedMessageData.guestsTotal = messageData.guestsTotal;
          parsedMessageData.guestsTotalHistory = messageData.guestsTotalHistory;
          parsedMessageData.guestsRemain = messageData.guestsRemain;
          parsedMessageData.guestsFreeTrialRemain = messageData.guestsFreeTrialRemain;
          parsedMessageData.guestsMax = messageData.guestsMax;
          parsedMessageData.guestsCurrentCount = messageData.guestsCurrentCount;
        }

        resolve(parsedMessageData);
      };

      if (data instanceof Blob) {
        fileReader.readAsArrayBuffer(data);
      }
    });
  }

  __prepareWebSocketMsgToPrimary(command, primaryId, additionalData) {
    // broadcastSettingsObj includes camera, scanMode, resolution, codec, frameRate, maxBitrate, streamType
    let arrBuffer;

    const typeArr = shortToByteArray(DASHBOARD_TO_PRIMARY_MSG);
    const idArr = longToByteArray(primaryId);
    let innerTypeArr;
    switch (command) {
      case 'start':
        innerTypeArr = shortToByteArray(START_SESSION_MSG);
        break;
      case 'stop':
        innerTypeArr = shortToByteArray(STOP_SESSION_MSG);
        break;
      case 'get settings':
        innerTypeArr = shortToByteArray(GET_PRIMARY_SETTINGS_MSG);
        break;
      case 'set settings':
        innerTypeArr = shortToByteArray(SET_PRIMARY_SETTINGS_MSG);
        break;
      case 'response dialog':
        innerTypeArr = shortToByteArray(DIALOG_ALERT_RESPONSE);
        break;
      case 'get records':
        innerTypeArr = shortToByteArray(GET_DEVICE_RECORDS);
        break;
      case 'start upload':
        innerTypeArr = shortToByteArray(START_RECORD_UPLOAD);
        break;
      case 'pause upload':
        innerTypeArr = shortToByteArray(PAUSE_RECORD_UPLOAD);
        break;
      case 'delete record':
        innerTypeArr = shortToByteArray(DELETE_RECORD);
        break;
      default:
        innerTypeArr = undefined;
    }

    if (
      command === 'start' ||
      command === 'stop' ||
      command === 'get settings' ||
      command === 'get records'
    ) {
      arrBuffer = new Int8Array(12);
      // The array structure is  XX    XXXXXXXX    XX
      // The array indexes are   0     2           10
      arrBuffer.set(typeArr, 0);
      arrBuffer.set(idArr, 2);
      arrBuffer.set(innerTypeArr, 10);
    } else if (
      command === 'set settings' ||
      command === 'response dialog' ||
      command === 'delete record' ||
      command === 'start upload' ||
      command === 'pause upload'
    ) {
      let dataArr;
      if (command === 'set settings') {
        let adjustedBroadcastSettingsObj = { ...additionalData };
        delete adjustedBroadcastSettingsObj.alarmsPrimary;
        let dataObj = {};
        for (let setting in adjustedBroadcastSettingsObj) {
          const tempObj = availableBroadcastSettingsObj[setting].find(
            (obj) => obj.value === adjustedBroadcastSettingsObj[setting]
          );
          dataObj[setting] = tempObj.type;
        }
        dataArr = Buffer.from(JSON.stringify(dataObj));
      } else {
        dataArr = Buffer.from(JSON.stringify(additionalData));
      }

      arrBuffer = new Int8Array(12 + dataArr.length);
      // The array structure is  XX    XXXXXXXX    XX    converted JSON (91)
      // The array indexes are   0     2           10    12
      arrBuffer.set(typeArr, 0);
      arrBuffer.set(idArr, 2);
      arrBuffer.set(innerTypeArr, 10);
      arrBuffer.set(dataArr, 12);
    }

    return arrBuffer;
  }

  __sendIfbMessagesToPrimaries(primaries, blob) {
    const fileReader = new FileReader();
    fileReader.onloadend = (e) => {
      const dataArr = e.srcElement.result; // arraybuffer object
      const typeArr = shortToByteArray(DASHBOARD_TO_PRIMARIES_MSG);
      let idsArr = [];

      Object.keys(primaries).forEach((key, index) => {
        // key: the name of the object key
        // index: the ordinal position of the key within the object

        const idArr = longToByteArray(key);
        idsArr.push(idArr);
      });

      // const idArr = longToByteArray(primaryId);
      const innerTypeArr = shortToByteArray(IFB_MSG);

      const MAX_FRAME_SIZE = 1024 * 512;
      const BYTES_PER_SAMPLE = this.state.IFBbytesPerSample;
      const SAMPLE_RATE = 48000;
      const RESAMPLING_RATIO = 2;
      const resampleRate = SAMPLE_RATE / RESAMPLING_RATIO;
      const calculatedConst = BYTES_PER_SAMPLE * (SAMPLE_RATE / resampleRate);
      const CHANNEL_COUNT = 2;

      let frameIndex = 0;
      for (let i = 0; i < dataArr.byteLength; i += MAX_FRAME_SIZE) {
        const indexArr = longToByteArray(frameIndex);
        frameIndex++;
        const sliceBuffer = new Int8Array(
          dataArr.slice(
            i,
            i + MAX_FRAME_SIZE > dataArr.length
              ? dataArr.length
              : i + MAX_FRAME_SIZE
          )
        );
        let cutLength = Math.floor(sliceBuffer.length / calculatedConst);
        cutLength = cutLength - (cutLength % 2);
        let cutSliceBuffer = new Int8Array(cutLength);
        for (
          let j = 0;
          j < sliceBuffer.length;
          j += CHANNEL_COUNT * calculatedConst
        ) {
          cutSliceBuffer[j / calculatedConst] = sliceBuffer[j];
          cutSliceBuffer[j / calculatedConst + 1] = sliceBuffer[j + 1];
        }

        let arrBuffer = new Int8Array(
          12 + 4 + 8 * idsArr.length + cutSliceBuffer.byteLength
        );
        // The array structure is  XX    XXXXXXXX    XX    XXXXXXXX    cutSliceBuffer.byteLength
        // The array indexes are   0     2           10    12          20
        arrBuffer.set(typeArr, 0);
        arrBuffer.set(intToByteArray(idsArr.length), 2);
        let offset = 6;
        idsArr.forEach((idArr) => {
          arrBuffer.set(idArr, offset);
          offset += 8;
        });
        // arrBuffer.set(idArr, 2);
        arrBuffer.set(innerTypeArr, offset);
        arrBuffer.set(indexArr, offset + 2);
        arrBuffer.set(cutSliceBuffer, offset + 2 + indexArr.length);

        this._webSocket.send(arrBuffer);
      }
    };

    fileReader.readAsArrayBuffer(blob);
  }

  __prepareWebSocketMsgToCentralServer(id, isDesignated) {
    const typeArr = shortToByteArray(DASHBOARD_TO_CENTRAL_SERVER_MSG);
    const innerTypeArr = shortToByteArray(SET_DESIGNATED_OUTPUT);
    const dataObj = {
      id,
      isDesignated,
    };
    const dataArr = Buffer.from(JSON.stringify(dataObj));

    const arrBuffer = new Int8Array(4 + dataArr.length);
    // The array structure is  XX    XX    converted JSON
    // The array indexes are   0     2     4
    arrBuffer.set(typeArr, 0);
    arrBuffer.set(innerTypeArr, 2);
    arrBuffer.set(dataArr, 4);

    return arrBuffer;
  }
  //---------------------------------------------------------------//

  //--------------------- REST calls methods ---------------------//
  getControllerInfo = (callbackFunc) => {
    axios({
      method: 'get',
      url: APIs.getControllerInfo,
      withCredentials: true,
      validateStatus: function (status) {
        return status >= 200;
      },
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.companyName !== undefined) {
            this.setState({
              companyName: response.data.companyName,
              adminFirstName: response.data.adminFirstName,
              adminLastName: response.data.adminLastName,
              email: response.data.email,
              phone: response.data.phoneNumber,
              companyType: response.data.type,
              companyId: response.data.id,
              primariesUserDetails: response.data.primaries,
              guestsTotal: response.data.guestsTotal,
              guestsTotalHistory: response.data.guestsTotalHistory,
              guestsRemain: response.data.guestsRemain,
              guestsFreeTrialRemain: response.data.guestsFreeTrialRemain,
              guestsMax: response.data.guestsMax,
              guestsCurrentCount: response.data.guestsCurrentCount,
            });
          }
          if (callbackFunc !== undefined) {
            callbackFunc();
          }
          if (!this.isWebSocketConnected()) {
            this.connectWebSocket();
          }
        } else if (response.status === 401 || response.status === 403) {
          this.props.setLogout();
        }
      })
      .catch((err) => {
        this.props.setLogout();
      });
  };

  _pollActivePrimariesHealth = (users) => {
    if (this.isWebSocketConnected()) {
      const primaries = users || this.state.primaryUsers;
      primaries.forEach((user) => {
        if (user.isActive) {
          this._requestPrimarySettings(user.id);
          this._requestPrimaryRecords(user.id);
        }
      });
    }
  };

  //-------------------------------------------------------------//

  _timerOfGetFocusedPrimaryBroadcastSettings;
  _isTimerOfGetFocusedPrimaryBroadcastSettingsSet = false;

  _requestPrimarySettings = (primaryId) => {
    const msg = this.__prepareWebSocketMsgToPrimary('get settings', primaryId);
    this._webSocket.send(msg);
  };

  _requestPrimaryRecords = (primaryId) => {
    const msg = this.__prepareWebSocketMsgToPrimary('get records', primaryId);
    this._webSocket.send(msg);
  };

  _buildSessionObject = (primaryId, existingSession = {}, incomingMetadata = {}) => {
    const {
      adminFirstName: propsAdminFirst,
      adminLastName: propsAdminLast,
      dashboardCompanyName: propsCompanyName,
    } = this.props;

    const {
      adminFirstName,
      adminLastName,
      companyName,
      email,
      phone,
      primariesUserDetails,
      outputs,
      outputsDisplayedNames,
      devicesSetsInfo,
      primaryUsers
    } = this.state;

    // Use state values as source of truth, fallback to props
    const finalAdminFirst = adminFirstName || propsAdminFirst;
    const finalAdminLast = adminLastName || propsAdminLast;
    const finalCompany = companyName || propsCompanyName;

    const userDetail = primariesUserDetails.find(u => parseInt(u.primaryId) === parseInt(primaryId)) || {};
    const associatedOutput = outputs.find(o => parseInt(o.primaryId) === parseInt(primaryId));
    const primaryObj = primaryUsers.find(u => u.id === primaryId) || {};

    return {
      startTime: existingSession.startTime || Date.now(),
      endTime: null,
      bitrateSamples: existingSession.bitrateSamples || [],
      duration: existingSession.duration || '00:00:00',
      primaryId: primaryId,
      primaryName: primaryObj.displayedName || primaryObj.username || existingSession.primaryName || 'Unknown User',
      targetBitrate: existingSession.targetBitrate || 'N/A',
      logs: existingSession.logs || [],
      alarms: existingSession.alarms || [],
      exports: existingSession.exports || [],
      exportLabels: existingSession.exportLabels || [],
      streamSettings: {
        ...(existingSession.streamSettings || {}),
        outputName: associatedOutput ? ((outputsDisplayedNames && outputsDisplayedNames[associatedOutput.id]) || associatedOutput.name) : (existingSession.streamSettings && existingSession.streamSettings.outputName) || 'None'
      },
      accountInfo: {
        adminName: [finalAdminFirst, finalAdminLast].filter(Boolean).join(' ') || 'N/A',
        email: email || 'N/A',
        phone: phone || 'N/A',
        company: finalCompany || 'N/A'
      },
      licenseInfo: {
        registrationDate: userDetail.registrationDate || 'N/A',
        expirationDate: userDetail.expirationDateReadable || userDetail.expirationDate || 'N/A',
        subscription: userDetail.licenseType || 'N/A',
        plan: Array.isArray(userDetail.licensePermission || userDetail.permissions)
          ? (userDetail.licensePermission || userDetail.permissions).join(', ')
          : (userDetail.licensePermission || userDetail.permissions || 'N/A'),
        platform: userDetail.deviceOS || 'N/A'
      },
      deviceInfo: devicesSetsInfo[primaryId] || existingSession.deviceInfo || [],
      connectivityEvents: existingSession.connectivityEvents || [],
      settingChanges: existingSession.settingChanges || [],
      maxSecondaries: existingSession.maxSecondaries || 0,
      location: {
        lat: primaryObj.latitude || (existingSession.location && existingSession.location.lat) || null,
        lng: primaryObj.longitude || (existingSession.location && existingSession.location.lng) || null
      },
      ...incomingMetadata // Allow overwriting/enriching with specific updates
    };
  };

  _getFocusedPrimaryBroadcastSettings = () => {
    this._requestPrimarySettings(this.state.focusedPrimaryId);
    this._requestPrimaryRecords(this.state.focusedPrimaryId);

    if (this._isTimerOfGetFocusedPrimaryBroadcastSettingsSet === true) {
      clearTimeout(this._timerOfGetFocusedPrimaryBroadcastSettings);
    }

    this._timerOfGetFocusedPrimaryBroadcastSettings = setTimeout(() => {
      this._isTimerOfGetFocusedPrimaryBroadcastSettingsSet = false;

      if (this.state.arePrimaryBroadcastSettingsLoading === true) {
        this.setState({
          focusedPrimaryBroadcastSettings: {},
          primaryRecordsDetails: [],
          arePrimaryBroadcastSettingsLoading: false,
          arePrimaryRecordsLoading: false,
        });
      }

      if (this.state.isDevicesSetsInfoLoading === true) {
        this.setState({
          isDevicesSetsInfoLoading: false,
        });
      }
    }, 3000);

    this.setState({
      focusedPrimaryBroadcastSettings: {},
      primaryRecordsDetails: [],
      arePrimaryBroadcastSettingsLoading: false,
      arePrimaryRecordsLoading: false,
    });
    this._isTimerOfGetFocusedPrimaryBroadcastSettingsSet = true;
  };

  _startSession = (primaryId, primaryObj) => {
    const { adminFirstName: propsAdminFirst, adminLastName: propsAdminLast, dashboardCompanyName: propsCompanyName } = this.props;
    this.setState(prevState => {
      const existingSession = prevState.primariesSessionData[primaryId] || {};
      const focusedPrimaryBroadcastSettings = prevState.focusedPrimaryBroadcastSettings;
      const outputs = prevState.outputs;
      const outputsDisplayedNames = prevState.outputsDisplayedNames;
      const primariesUserDetails = prevState.primariesUserDetails;
      const devicesSetsInfo = prevState.devicesSetsInfo;

      // Use state values as source of truth (from getControllerInfo), fallback to props
      const finalAdminFirst = prevState.adminFirstName || propsAdminFirst;
      const finalAdminLast = prevState.adminLastName || propsAdminLast;
      const finalCompany = prevState.companyName || propsCompanyName;

      const userDetail = primariesUserDetails.find(u => parseInt(u.primaryId) === parseInt(primaryId)) || {};
      const associatedOutput = outputs.find(o => parseInt(o.primaryId) === parseInt(primaryId));

      const newSession = this._buildSessionObject(primaryId, existingSession, {
        primaryName: primaryObj.displayedName || primaryObj.username,
        targetBitrate: (primaryId === prevState.focusedPrimaryId && focusedPrimaryBroadcastSettings && focusedPrimaryBroadcastSettings.maxBitrate)
          ? focusedPrimaryBroadcastSettings.maxBitrate
          : (existingSession.streamSettings && existingSession.streamSettings.maxBitrate ? existingSession.streamSettings.maxBitrate : (existingSession.targetBitrate || 'N/A')),
        streamSettings: {
          ...(primaryId === prevState.focusedPrimaryId ? focusedPrimaryBroadcastSettings : (existingSession.streamSettings || {})),
          outputName: associatedOutput ? ((outputsDisplayedNames && outputsDisplayedNames[associatedOutput.id]) || associatedOutput.name) : (existingSession.streamSettings && existingSession.streamSettings.outputName) || 'None'
        }
      });

      return {
        primariesSessionData: {
          ...prevState.primariesSessionData,
          [primaryId]: newSession
        }
      };
    });
  };

  _stopSession = (primaryId, deviceName) => {
    const session = this.state.primariesSessionData[primaryId];
    if (!session) return;

    const logsSnapshot = [...(this.state.primariesLogs[primaryId] || [])];
    const alarmsSnapshot = [...(this.state.primariesAlarms[primaryId] || [])];

    // Fetch exports and finalize
    Promise.all([
      axios({
        method: 'get',
        url: EXPORT_APIS.getExportList(primaryId),
        withCredentials: true,
      }),
      axios({
        method: 'get',
        url: EXPORT_APIS.getExportLabels(primaryId),
        withCredentials: true,
      })
    ]).then(([listRes, labelsRes]) => {
      const exports = listRes.data.exports || [];
      const exportLabels = labelsRes.data.exports || [];

      const {
        adminFirstName, adminLastName, companyName, email, phone, primariesUserDetails
      } = this.state; // state also has props values if needed? No, use props for fallback

      // Fallback logic again for safety at stop time
      const finalAdminFirst = adminFirstName || this.props.adminFirstName;
      const finalAdminLast = adminLastName || this.props.adminLastName;
      const finalCompany = companyName || this.props.dashboardCompanyName;

      const userDetail = primariesUserDetails.find(u => parseInt(u.primaryId) === parseInt(primaryId)) || {};

      const finalizedSession = {
        ...session,
        endTime: Date.now(),
        logs: [...(session.logs || []), ...logsSnapshot], // Merge session logs with global logs
        alarms: [...(session.alarms || []), ...alarmsSnapshot], // Merge history (headset) with snapshot (server alarms)
        exports: exports,
        exportLabels: exportLabels,
        // Enrich with latest account info in case startSession missed it
        accountInfo: {
          adminName: [finalAdminFirst, finalAdminLast].filter(Boolean).join(' ') || 'N/A',
          email: email || 'N/A',
          phone: phone || 'N/A',
          company: finalCompany || 'N/A'
        },
        licenseInfo: {
          registrationDate: userDetail.registrationDate || 'N/A',
          expirationDate: userDetail.expirationDateReadable || userDetail.expirationDate || 'N/A',
          subscription: userDetail.licenseType || 'N/A',
          plan: Array.isArray(userDetail.licensePermission || userDetail.permissions)
            ? (userDetail.licensePermission || userDetail.permissions).join(', ')
            : (userDetail.licensePermission || userDetail.permissions || 'N/A'),
          platform: userDetail.deviceOS || 'N/A'
        },
        location: session.location // Preserve location from start/updates
      };

      finalizedSession.streamScore = calculateStreamScore(finalizedSession, config.dashboard.streamReports);
      const report = saveReportToHistory(finalizedSession, this.state.companyId);

      // Clear from active sessions
      this.setState(prevState => {
        const nextSessions = { ...prevState.primariesSessionData };
        delete nextSessions[primaryId];

        // Clear logs if configured
        let nextLogs = { ...prevState.primariesLogs };
        if (config.dashboard.logsAndAlerts.logs.clearUserLogsOnSessionStop) {
          nextLogs[primaryId] = [];
        }

        return {
          primariesSessionData: nextSessions,
          primariesLogs: nextLogs
        };
      }, () => {
        if (config.dashboard.streamReports.notifyUser) {
          const message = `Stream session for ${deviceName} ended. Report saved to Session History.`;
          this.showNotification('stream_stopped', message, { reportId: report ? report.id : null });
        }
      });
    }).catch(err => {
      console.error('Failed to fetch exports for report in Main.js', err);
      const finalizedSession = {
        ...session,
        endTime: Date.now(),
        logs: [...(session.logs || []), ...logsSnapshot],
        alarms: [...(session.alarms || []), ...alarmsSnapshot]
      };
      finalizedSession.streamScore = calculateStreamScore(finalizedSession, config.dashboard.streamReports);
      saveReportToHistory(finalizedSession, this.state.companyId);

      this.setState(prevState => {
        const nextSessions = { ...prevState.primariesSessionData };
        delete nextSessions[primaryId];

        // Clear logs if configured (even on failure)
        let nextLogs = { ...prevState.primariesLogs };
        if (config.dashboard.logsAndAlerts.logs.clearUserLogsOnSessionStop) {
          nextLogs[primaryId] = [];
        }

        return {
          primariesSessionData: nextSessions,
          primariesLogs: nextLogs
        };
      });
    });
  };

  _handlePrimariesStartStopStateChange = (newPrimariesArr) => {
    const prevPrimariesArr = [...this.state.primaryUsers];
    prevPrimariesArr.forEach((prevPrimaryObj) => {
      const newPrimaryObj = newPrimariesArr.find(
        (obj) => obj.id === prevPrimaryObj.id
      );
      if (newPrimaryObj !== undefined) {
        // 1. Handle explicit start/stop state changes
        if (newPrimaryObj.isBroadcasting !== prevPrimaryObj.isBroadcasting) {
          if (newPrimaryObj.id === this.state.focusedPrimaryId) {
            this.setState({ isChangingStartStopInProgress: false });
          }

          if (newPrimaryObj.isBroadcasting === true) {
            this._requestPrimarySettings(newPrimaryObj.id);
            this._requestPrimaryRecords(newPrimaryObj.id);
            this._startSession(newPrimaryObj.id, newPrimaryObj);

            this.setState(prevState => {
              let primariesBroadcastDetails = [...prevState.primariesBroadcastDetails];
              let broadcastProperties = [...prevState.broadcastProperties];
              const i = primariesBroadcastDetails.findIndex(obj => obj.primaryId === newPrimaryObj.id);
              const k = broadcastProperties.findIndex(obj => obj.primaryId === newPrimaryObj.id);

              if (i > -1) {
                primariesBroadcastDetails[i].bitrateArr = [];
                primariesBroadcastDetails[i].durationArr = [];
                primariesBroadcastDetails[i].operatorsDataArr = [];
              }
              if (k > -1) {
                broadcastProperties[k].bitrateArr = [];
                broadcastProperties[k].durationArr = [];
              }
              return { primariesBroadcastDetails, broadcastProperties };
            });
          } else {
            const deviceName = newPrimaryObj.displayedName || newPrimaryObj.username;
            this._stopSession(newPrimaryObj.id, deviceName);

            // Clear chart and connection data immediately on stop
            this.setState(prevState => {
              let primariesBroadcastDetails = [...prevState.primariesBroadcastDetails];
              let broadcastProperties = [...prevState.broadcastProperties];
              const i = primariesBroadcastDetails.findIndex(obj => obj.primaryId === newPrimaryObj.id);
              const k = broadcastProperties.findIndex(obj => obj.primaryId === newPrimaryObj.id);

              if (i > -1) {
                primariesBroadcastDetails[i].bitrateArr = [];
                primariesBroadcastDetails[i].durationArr = [];
                primariesBroadcastDetails[i].operatorsDataArr = [];
              }
              if (k > -1) {
                broadcastProperties[k].bitrateArr = [];
                broadcastProperties[k].durationArr = [];
              }
              return { primariesBroadcastDetails, broadcastProperties };
            });
          }
        }
        // 2. Initial Sync Case: Dashboard refreshed while primary is ALREADY broadcasting
        else if (newPrimaryObj.isBroadcasting === true && !this.state.primariesSessionData[newPrimaryObj.id]) {
          console.log(`Re-joining active session for ${newPrimaryObj.id}`);
          this._startSession(newPrimaryObj.id, newPrimaryObj);
        }
      }
    });
  };

  _formatBitrateToString = (bitrate) => {
    let formatedBitrate = '';
    const temp = Math.round(bitrate * 100);
    formatedBitrate = (temp / 100).toString();

    if (temp % 100 === 0) {
      formatedBitrate += '.00';
    } else if (temp % 10 === 0) {
      formatedBitrate += '0';
    }

    return formatedBitrate;
  };

  _formatDurationToString = (duration) => {
    let hoursStr, minutesStr, secondsStr;

    const hours = Math.floor(duration / 3600);
    if (hours === 0) {
      hoursStr = '';
    } else {
      hoursStr = hours.toString();
      if (hours / 10 < 1) {
        hoursStr = '0' + hoursStr;
      }
    }

    const minutes = Math.floor((duration % 3600) / 60);
    minutesStr = minutes.toString();
    if (minutes / 10 < 1) {
      minutesStr = '0' + minutesStr;
    }

    const seconds = duration % 60;
    secondsStr = seconds.toString();
    if (seconds / 10 < 1) {
      secondsStr = '0' + secondsStr;
    }

    return hoursStr
      ? `${hoursStr}:${minutesStr}:${secondsStr}`
      : `${minutesStr}:${secondsStr}`;
  };

  //------------- App tabs switching related methods -------------//
  handlePagesSwitch = (e) => {
    const showDashboardPage = e.target.id === 'dashboard';
    const showMapPage = e.target.id === 'map';

    this.setState(
      {
        showDashboardPage,
        showMapPage,
      },
      () => {
        this.savePagesTabsStateToLocalStorage();
      }
    );
  };

  savePagesTabsStateToLocalStorage = () => {
    const { showDashboardPage, showMapPage } = this.state;
    const pagesTabsState = { showDashboardPage, showMapPage };
    localStorage.setItem('pagesTabsState', JSON.stringify(pagesTabsState));
  };
  //------------------------------------------------------------//

  //----------- Buttons and elements click handlers ------------//
  handlePrimaryFocus = (primaryId) => {
    let audioDevices = this.state.audioDevices;
    let selectedDevice = ''; //audioDevices[0];

    audioDevices.forEach((audioDevice) => {
      if (audioDevice.primaries[primaryId] !== undefined) {
        selectedDevice = audioDevice;
      }
    });
    let isAudioChannelOpen = selectedDevice.open;

    this.setState(
      {
        focusedPrimaryId: primaryId,
        isChangingStartStopInProgress: false,
        arePrimaryBroadcastSettingsLoading: primaryId !== '',
        arePrimaryRecordsLoading: primaryId !== '',
        isDevicesSetsInfoLoading: primaryId !== '',
        selectedDevice: selectedDevice,
        isAudioChannelOpen: isAudioChannelOpen,
      },
      () => {
        if (primaryId !== '') {
          this._getFocusedPrimaryBroadcastSettings();
        }
      }
    );
  };

  handleStartStopClick = () => {
    this.setState({ isChangingStartStopInProgress: true });
    const { primaryUsers, focusedPrimaryId } = this.state;
    const focusedPrimaryObj = primaryUsers.find(
      (obj) => obj.id === focusedPrimaryId
    );

    const command = !focusedPrimaryObj.isBroadcasting ? 'start' : 'stop';
    const msg = this.__prepareWebSocketMsgToPrimary(command, focusedPrimaryId);
    this._webSocket.send(msg);

    setTimeout(() => {
      if (this.state.isChangingStartStopInProgress === true) {
        this.setState({ isChangingStartStopInProgress: false });
      }
    }, 5000);
  };

  handleSettingsApplyClick = (newSettingsObj) => {
    const msg = this.__prepareWebSocketMsgToPrimary(
      'set settings',
      this.state.focusedPrimaryId,
      newSettingsObj
    );
    this._webSocket.send(msg);
  };

  handleLogsClear = (primaryId) => {
    let primariesLogs = { ...this.state.primariesLogs };
    primariesLogs[primaryId] = [];

    this.setState({ primariesLogs });
  };

  handleAlertDialogButtonsClick = (isConfirmed) => {
    this.setState({
      isAlertDialogDisplayed: false,
      isChangingStartStopInProgress: false,
    });
    const response = {
      dialogType: this.state.currentAlertDialogType,
      isConfirmed,
    };
    const msg = this.__prepareWebSocketMsgToPrimary(
      'response dialog',
      this.state.alertDialogPrimaryId,
      response
    );
    this._webSocket.send(msg);
  };

  //-----------------------------------------------------------//

  //------------------- IFB related methods -------------------//
  _openIFBchannel = (selectedDevice) => {
    if (
      this._recorders[selectedDevice.id] !== undefined &&
      !selectedDevice.open
    ) {
      this._recorders[selectedDevice.id].start(30);
      selectedDevice.open = true;
      this.setState({
        selectedDevice: selectedDevice,
        isAudioChannelOpen: true,
      });
    }
  };

  _closeIFBchannel = (selectedDevice) => {
    if (
      this._recorders[selectedDevice.id] !== undefined &&
      selectedDevice.open
    ) {
      this._recorders[selectedDevice.id].stop();
      selectedDevice.open = false;
      this.setState({
        selectedDevice: selectedDevice,
        isAudioChannelOpen: false,
      });
    }
  };

  handleIFBdownEvents = (selectedDevice) => {
    if (selectedDevice) {
      this._openIFBchannel(selectedDevice);
    }
  };

  handleIFBupEvents = (selectedDevice) => {
    if (selectedDevice) {
      this._closeIFBchannel(selectedDevice);
    }
  };

  // handleSpacebarKeyEvents = eventName => {
  // 	if (this.state.isPrimaryFocused === true) {
  // 		const primaryObj = this.state.primaryUsers.find(
  // 			obj => obj.id === this.state.focusedPrimaryId
  // 		);
  // 		if (primaryObj.isActive === true) {
  // 			if (eventName === 'keydown') {
  // 				this.state.isIfbButtonLocked
  // 					? this.handleIFBpressEvents()
  // 					: this.handleIFBdownEvents();
  // 			} else if (eventName === 'keyup') {
  // 				this.handleIFBupEvents();
  // 			}
  // 		}
  // 	}
  // };

  handleStartRecordUpload = (recordName) => {
    this.sendRecordActionMessage('start upload', recordName);
  };

  handlePauseRecordUpload = (recordName) => {
    this.sendRecordActionMessage('pause upload', recordName);
  };

  handleDeleteRecord = (recordName) => {
    this.sendRecordActionMessage('delete record', recordName);
  };

  onAttachPrimary = (selectedDevice, primaryId) => {
    const focusedPrimaryPrevObj = this.state.primaryUsers.find(
      (obj) => obj.id === primaryId
    );
    if (focusedPrimaryPrevObj === undefined) {
      return;
    }
    let audioDevices = this.state.audioDevices;
    audioDevices.forEach((audioDevice) => {
      if (audioDevice.id === selectedDevice.id && selectedDevice.id !== '') {
        audioDevice.primaries[focusedPrimaryPrevObj.id] =
          focusedPrimaryPrevObj.username;
      } else {
        delete audioDevice.primaries[focusedPrimaryPrevObj.id];
      }
    });
    this.setState({ toggleRefresh: !this.state.toggleRefresh });
  };

  onDettachPrimary = (selectedDevice, primaryId) => {
    delete selectedDevice.primaries[primaryId];
    if (Object.keys(selectedDevice.primaries).length === 0) {
      this._closeIFBchannel(selectedDevice);
    }
    this.setState({ toggleRefresh: !this.state.toggleRefresh });
  };

  onAudioSelect = (selectedDevice) => {
    this.createRecorder(selectedDevice.id);
    this.setState({
      selectedDevice: selectedDevice,
      isAudioChannelOpen: selectedDevice.open,
    });
  };

  sendRecordActionMessage(command, recordName) {
    const additionalData = {
      name: recordName,
    };

    const msg = this.__prepareWebSocketMsgToPrimary(
      command,
      this.state.focusedPrimaryId,
      additionalData
    );
    this._webSocket.send(msg);
  }

  changeIFBbytesPerSample = (value) => {
    this.setState({ IFBbytesPerSample: value });
  };
  //-----------------------------------------------------------//

  //--------------- Notification related methods ---------------//
  _notificationTimer;

  showNotification = (type, data, metadata = {}) => {
    const newNotification = {
      id: Date.now(),
      type: type,
      message: data,
      timestamp: new Date(),
      isRead: false,
      metadata: metadata
    };

    this.setState(
      (prevState) => ({
        isNotificationDisplayed: true,
        currentNotificationType: type,
        notificationMsg: data,
        notificationsHistory: [newNotification, ...prevState.notificationsHistory].slice(0, 50), // Keep last 50
      }),
      () => {
        clearTimeout(this._notificationTimer);
        this._notificationTimer = setTimeout(() => {
          this.hideNotification();
        }, 5000);
      }
    );
  };

  markAllNotificationsAsRead = () => {
    this.setState((prevState) => ({
      notificationsHistory: prevState.notificationsHistory.map(n => ({ ...n, isRead: true }))
    }));
  };

  markNotificationAsRead = (id) => {
    this.setState((prevState) => ({
      notificationsHistory: prevState.notificationsHistory.map(n =>
        n.id === id ? { ...n, isRead: true } : n
      )
    }));
  };

  clearNotificationsHistory = () => {
    this.setState({ notificationsHistory: [] });
  };

  hideNotification = () => {
    this.setState({ isNotificationDisplayed: false });
  };
  //-----------------------------------------------------------//

  setDisplayedName = (type, id, newName) => {
    const identificator =
      type === 'Primary' ? 'primariesDisplayedNames' : 'outputsDisplayedNames';

    let displayedNamesArr = { ...this.state[identificator] };
    displayedNamesArr[id] = newName;

    this.setState({ [identificator]: displayedNamesArr }, () => {
      localStorage.setItem(
        [identificator],
        JSON.stringify(this.state[identificator])
      );
    });
  };

  checkPermissions() {
    const permissions = navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    permissions
      .then((stream) => {
        //   alert('accepted the permissions');
        this.getAudioDevices();
      })
      .catch((err) => {
        console.log(`${err.name} : ${err.message}`);
      });
  }

  formOperatorsData = (bitrate, operators, isPrimaryBroadcast) => {
    let broadcastOperatorsArray = operators.providers;
    let totalDeliveredPackets = operators.totalDeliveredPackets;
    let data = [];
    for (let index = 0; index < broadcastOperatorsArray.length; index++) {
      let broadcastOperatorJsonObject = broadcastOperatorsArray[index];
      let deliveredPackets = broadcastOperatorJsonObject['deliveredPackets'];
      let chartPortionParam = Math.round(
        (deliveredPackets * 100) / totalDeliveredPackets
      );
      chartPortionParam = (bitrate * chartPortionParam) / 100;
      if (totalDeliveredPackets === 0) chartPortionParam = 0;
      let chartNamesParam = broadcastOperatorJsonObject['providerName'];
      if (isPrimaryBroadcast) {
        const operatorData = {
          id: index + 'operator',
          operatorName: chartNamesParam,
          operatorData: [this._formatBitrateToString(chartPortionParam)],
          deliveredPackets: deliveredPackets // Capture cumulative packets for reports
        };
        data.push(operatorData);
      } else {
        const operatorData = {
          id: index + 'operator',
          operatorName: chartNamesParam,
          operatorData: this._formatBitrateToString(chartPortionParam),
          deliveredPackets: deliveredPackets // Capture cumulative packets for reports
        };
        data.push(operatorData);
      }
    }
    return data;
  };

  updatePrimariesBrodcastDetails = (
    formatedBitrate,
    formatedDuration,
    formatedOperatorsArr,
    primariesBroadcastDetails,
    i
  ) => {
    const primary = { ...primariesBroadcastDetails[i] };

    primary.bitrateArr = [...primary.bitrateArr, formatedBitrate].slice(-300);
    primary.durationArr = [...primary.durationArr, formatedDuration].slice(-300);

    const newOperatorsDataArr = [];

    formatedOperatorsArr.forEach((formattedOperator) => {
      const existingOperator = primary.operatorsDataArr.find(
        (op) => op.id === formattedOperator.id
      );

      if (existingOperator) {
        const updatedData = [...existingOperator.operatorData, formattedOperator.operatorData].slice(-300);
        newOperatorsDataArr.push({
          id: formattedOperator.id,
          operatorName: formattedOperator.operatorName,
          operatorData: updatedData,
        });
      } else {
        newOperatorsDataArr.push({
          id: formattedOperator.id,
          operatorName: formattedOperator.operatorName,
          operatorData: [formattedOperator.operatorData],
        });
      }
    });

    primary.operatorsDataArr = newOperatorsDataArr;

    // const operatorNames = primariesBroadcastDetails[i].operatorsDataArr.map((op) => op.operatorName)
    // console.log('Operator names: (updatePrimariesBrodcastDetails)', operatorNames);
    return primary;
  };

  setFetchExportListFn = (fn) => {
    this.setState({ ...this.state, fetchExportList: fn })
  }

  render() {
    const {
      companyName,
      adminFirstName,
      adminLastName,
      primaryUsers,
      primariesDisplayedNames,
      arePrimaryUsersLoading,
      broadcastDetailsJsonObject,
      outputs,
      outputsDisplayedNames,
      areOutputsLoading,
      videoServerStatus,

      focusedPrimaryId,
      isChangingStartStopInProgress,

      focusedPrimaryBroadcastSettings,
      arePrimaryBroadcastSettingsLoading,
      arePrimaryRecordsLoading,
      primaryRecordsDetails,

      primariesAlarms,
      primariesLogs,
      primariesBroadcastDetails,
      isUserCorporate,
      isUserVideographer,
      isUserInfluencer,
      isUserFreeTrial,
      isUserMyKey,
      isUserBasic,
      isUserLiveOmni,
      isUserGuest,
      broadcastProperties,
      devicesSetsInfo,
      isDevicesSetsInfoLoading,

      isNotificationDisplayed,
      currentNotificationType,
      notificationMsg,

      isAlertDialogDisplayed,
      currentAlertDialogType,

      showDashboardPage,
      showMapPage,

      audioDevices,
      selectedDevice,
      isAudioChannelOpen,
      companyType,

      guestsTotal,
      guestsTotalHistory,
      guestsRemain,
      guestsFreeTrialRemain,
      guestsMax,
      guestsCurrentCount,
      primariesUserDetails,
      fetchExportList,
      notificationsHistory,
    } = this.state;

    const {
      // companyType,
      screenSize,
    } = this.props;



    const filteredPrimaryUsersWithDisplayedName = primaryUsers.map(
      ({
        id,
        username,
        isActive,
        isBroadcasting,
        type,
        url,
        latitude,
        longitude,
        Statuses,
        outputAddressId,
        expiration,
      }) => {
        const statuses = Statuses || [];
        const displayedName = primariesDisplayedNames[id]
          ? primariesDisplayedNames[id]
          : '';
        const userDetail = primariesUserDetails.find(user => user.primaryId === id);
        const licensePermission = userDetail ? userDetail.licensePermission : null;
        const licensePermissionId = userDetail ? userDetail.licensePermissionId : null;
        const licenseTypeId = userDetail ? userDetail.licenseTypeId : null;
        const deviceOS = userDetail ? userDetail.deviceOS : null;
        const licenseSource = userDetail ? userDetail.licenseSource : null;
        return {
          id,
          username,
          displayedName,
          isActive,
          isBroadcasting,
          type,
          url,
          latitude,
          longitude,
          statuses,
          outputAddressId,
          daysToExpire: (Date.parse(expiration) - Date.now()) / 86400000,
          licensePermission,
          licensePermissionId,
          licenseTypeId,
          deviceOS,
          licenseSource,
        };
      }
    );

    const filteredOutputsWithDisplayedName = outputs.map(
      ({
        id,
        name,
        uuid,
        isActive,
        isDesignated,
        GeneralStatus,
        Statuses,
        primaryId,
      }) => {
        const generalStatus = GeneralStatus;
        const statuses = Statuses || [];
        const displayedName = outputsDisplayedNames[id]
          ? outputsDisplayedNames[id]
          : '';
        return {
          id,
          name,
          uuid,
          displayedName,
          isActive,
          isDesignated,
          generalStatus,
          statuses,
          primaryId,
        };
      }
    );

    const trimmedPrimariesBroadcastDetails = primariesBroadcastDetails.map(
      ({ primaryId, bitrateArr, durationArr }) => {
        return {
          primaryId,
          bitrate: bitrateArr[bitrateArr.length - 1],
          duration: durationArr[durationArr.length - 1],
        };
      }
    );

    const trimmedBroadcastProperties = broadcastProperties.map(
      ({ primaryId, bitrateArr, durationArr }) => {
        return {
          primaryId,
          bitrate: bitrateArr[bitrateArr.length - 1],
          duration: durationArr[durationArr.length - 1],
        };
      }
    );

    let focusedPrimayBroadcastDetails = {};
    let focusedPrimayDevicesSetInfo = [];
    let focusedPrimaryVideoAlarms = [];
    let focusedPrimaryLogs = [];

    if (focusedPrimaryId) {
      focusedPrimayBroadcastDetails = primariesBroadcastDetails.find(
        (obj) => obj.primaryId === focusedPrimaryId
      );
      focusedPrimayBroadcastDetails = focusedPrimayBroadcastDetails || {};

      if (devicesSetsInfo[focusedPrimaryId] !== undefined) {
        focusedPrimayDevicesSetInfo = devicesSetsInfo[focusedPrimaryId];
      }

      if (primariesAlarms[focusedPrimaryId] !== undefined) {
        focusedPrimaryVideoAlarms = primariesAlarms[focusedPrimaryId];
      }

      if (primariesLogs[focusedPrimaryId] !== undefined) {
        focusedPrimaryLogs = primariesLogs[focusedPrimaryId];
      }
    }

    const focusedPrimary = primariesUserDetails.find(({ primaryId }) => primaryId === focusedPrimaryId);
    const dashboardCompanyName = companyName.charAt(0).toUpperCase() + companyName.substring(1);
    const dashboardAdminFirstName = adminFirstName.charAt(0).toUpperCase() + adminFirstName.substring(1);
    const dashboardAdminLastName = adminLastName.charAt(0).toUpperCase() + adminLastName.substring(1);
    return (
      <div className="main">
        <HashRouter>
          <Header
            {...this.props}
            dashboardCompanyName={dashboardCompanyName}
            dashboardAdminFirstName={dashboardAdminFirstName}
            dashboardAdminLastName={dashboardAdminLastName}
            logout={this.closeConnectionToServer}
            focusedPrimary={focusedPrimary}
            guestsInfo={{ guestsTotal, guestsTotalHistory, guestsRemain, guestsFreeTrialRemain, guestsMax, guestsCurrentCount }}
            filteredOutputs={filteredOutputsWithDisplayedName}
            companyType={companyType}
            isAtLeastOneCorporateLicense={this.isAtLeastOneCorporateLicense()}
            isNotificationDisplayed={isNotificationDisplayed}
            currentNotificationType={currentNotificationType}
            notificationMsg={notificationMsg}
            showDashboardPage={showDashboardPage}
            showMapPage={showMapPage}
            handlePagesSwitch={this.handlePagesSwitch}
            hideNotification={this.hideNotification}
            showNotification={this.showNotification}
            handlePrimaryFocus={this.handlePrimaryFocus}
            primaryUsers={primaryUsers}
            getControllerInfo={this.getControllerInfo}
            fetchExportList={fetchExportList}
            setDisplayedName={this.setDisplayedName}
            notificationsHistory={notificationsHistory}
            markAllNotificationsAsRead={this.markAllNotificationsAsRead}
            markNotificationAsRead={this.markNotificationAsRead}
            clearNotificationsHistory={this.clearNotificationsHistory}
          />
          <Switch>
            <Redirect exact from="/" to="/dashboard" />
            <Route path="/dashboard">
              <Dashboard
                isWebSocketConnected={this.isWebSocketConnected()}
                primaryUsers={filteredPrimaryUsersWithDisplayedName}
                broadcastDetailsJsonObject={broadcastDetailsJsonObject}
                arePrimaryUsersLoading={arePrimaryUsersLoading}
                outputs={filteredOutputsWithDisplayedName}
                areOutputsLoading={areOutputsLoading}
                videoServerStatus={videoServerStatus}
                focusedPrimaryId={focusedPrimaryId}
                isChangingStartStopInProgress={isChangingStartStopInProgress}
                primariesBroadcastDetails={trimmedPrimariesBroadcastDetails}
                isUserCorporate={isUserCorporate}
                isUserVideographer={isUserVideographer}
                isUserInfluencer={isUserInfluencer}
                isUserFreeTrial={isUserFreeTrial}
                isUserMyKey={isUserMyKey}
                isUserBasic={isUserBasic}
                isUserLiveOmni={isUserLiveOmni}
                isUserGuest={isUserGuest}
                broadcastProperties={trimmedBroadcastProperties}
                focusedPrimaryBroadcastSettings={
                  focusedPrimaryBroadcastSettings
                }
                arePrimaryBroadcastSettingsLoading={
                  arePrimaryBroadcastSettingsLoading
                }
                arePrimaryRecordsLoading={arePrimaryRecordsLoading}
                focusedPrimayBroadcastDetails={focusedPrimayBroadcastDetails}
                primaryRecordsDetails={primaryRecordsDetails}
                focusedPrimayDevicesSetInfo={focusedPrimayDevicesSetInfo}
                isDevicesSetsInfoLoading={isDevicesSetsInfoLoading}
                focusedPrimaryVideoAlarms={focusedPrimaryVideoAlarms}
                focusedPrimaryLogs={focusedPrimaryLogs}
                isBitrateChartDisplayed={showDashboardPage}
                isAlertDialogDisplayed={isAlertDialogDisplayed}
                alertDialogType={alertDialogType[currentAlertDialogType]}
                screenSize={screenSize}
                companyType={companyType}
                showNotification={this.showNotification}
                handlePrimaryFocus={this.handlePrimaryFocus}
                setDisplayedName={this.setDisplayedName}
                clickStartStop={this.handleStartStopClick}
                clickIFBmouseDown={this.handleIFBdownEvents}
                clickIFBmouseUp={this.handleIFBupEvents}
                clickSettingsApply={this.handleSettingsApplyClick}
                clickLogsClear={this.handleLogsClear}
                onAlertDialogClick={this.handleAlertDialogButtonsClick}
                handleStartRecordUpload={this.handleStartRecordUpload}
                handlePauseRecordUpload={this.handlePauseRecordUpload}
                handleDeleteRecord={this.handleDeleteRecord}
                onAudioSelect={this.onAudioSelect}
                onAttachPrimary={this.onAttachPrimary}
                onDettachPrimary={this.onDettachPrimary}
                audioDevices={audioDevices}
                selectedDevice={selectedDevice}
                isAudioChannelOpen={isAudioChannelOpen}
                setFetchExportListFn={this.setFetchExportListFn}
                dashboardCompanyName={dashboardCompanyName}
                outputsDisplayedNames={this.state.outputsDisplayedNames}
                adminFirstName={adminFirstName}
                adminLastName={adminLastName}
                email={this.state.email}
                phone={this.state.phone}
                companyName={companyName}
                primariesUserDetails={primariesUserDetails}
              />
            </Route>
            <Route path="/reports/:reportId?">
              <Reports
                companyId={this.state.companyId}
                dashboardCompanyName={dashboardCompanyName}
                dashboardAdminFirstName={dashboardAdminFirstName}
                dashboardAdminLastName={dashboardAdminLastName}
                email={this.state.email}
                phone={this.state.phone}
                primariesUserDetails={primariesUserDetails}
                primariesDisplayedNames={primariesDisplayedNames}
                screenSize={screenSize}
              />
            </Route>
            <Route path="/map">
              <Map
                primaryUsers={filteredPrimaryUsersWithDisplayedName.map(
                  ({
                    id,
                    username,
                    displayedName,
                    isActive,
                    isBroadcasting,
                    latitude,
                    longitude,
                  }) => {
                    return {
                      id,
                      username,
                      displayedName,
                      isActive,
                      isBroadcasting,
                      latitude,
                      longitude,
                    };
                  }
                )}
                primariesBroadcastDetails={trimmedPrimariesBroadcastDetails}
                focusedPrimaryId={focusedPrimaryId}
                isChangingStartStopInProgress={isChangingStartStopInProgress}
                devicesSetsInfo={devicesSetsInfo}
                screenSize={this.props.screenSize}
                handlePrimaryFocus={this.handlePrimaryFocus}
                clickStartStop={this.handleStartStopClick}
                clickIFBmouseDown={this.handleIFBdownEvents}
              />
            </Route>
            <Route path="/account">
              <UserArea
                companyName={dashboardCompanyName}
                adminFirstName={dashboardAdminFirstName}
                adminLastName={dashboardAdminLastName}
                email={this.state.email}
                phone={this.state.phone}
                primariesUserDetails={primariesUserDetails}
                connectedPrimaries={primaryUsers}
              />
            </Route>
          </Switch>
          <div className="container-fluid">
            <Modal
              uniqueId="codec-rtmp-conflict-modal"
              headerTitle="Pay attention"
              showExclamationIcon={true}
              buttons={[{ name: 'Close', className: 'info' }]}
            >
              <p>RTMP streaming can not be done when H.265 codec is used.</p>
              <p>Clicking "Apply" button below will disable RTMP streaming.</p>
            </Modal>
            <IfbModal changeIFBbytesPerSample={this.changeIFBbytesPerSample} />
          </div>
        </HashRouter>
      </div>
    );
  }
}

Main.propTypes = {
  setLogout: PropTypes.func.isRequired,
};

export default Main;
